type CategoryQueryParameter = 'categories' | 'hvdCategories';
type CategoryLink = {
  path: string;
  query: { categories?: string; hvdCategories?: string; locale: string | undefined };
};

/** Builds a datasets route location filtered by the selected category. */
export const getCategoryLink = (
  categoryID: string,
  locale: string | undefined,
  queryParameter: CategoryQueryParameter = 'categories',
): CategoryLink => ({
  path: '/datasets',
  query: { [queryParameter]: categoryID, locale },
});
